import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Course, CourseDto } from '@app/store/shared/models';
import { CourseValue, CourseValueDto } from '../models';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private httpClient = inject(HttpClient);

    getCourse(id: string): Observable<Course> {
        return this.httpClient.get<CourseDto>(`courses/${id}`).pipe(map((dto) => new Course(dto)));
    }

    createCourse(value: CourseValue): Observable<Course> {
        const dto = new CourseValueDto(value);

        return this.httpClient.post<CourseDto>('courses', dto).pipe(map((response) => new Course(response)));
    }

    updateCourse(id: string, value: CourseValue): Observable<Course> {
        const dto = new CourseValueDto(value);

        return this.httpClient.patch<CourseDto>(`courses/${id}`, dto).pipe(map((response) => new Course(response)));
    }

    deleteCourse(id: string): Observable<void> {
        return this.httpClient.delete<void>(`courses/${id}`);
    }
}
